// Write your JS code here
import './index.css'

const UserInfo = () => (
  <div className="user-info-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/profile-img.png"
      alt="profile"
      className="profile-img"
    />
    <h1 className="user-title">Wade Warren</h1>
    <p className="user-role">Software Developer at UK</p>
  </div>
)

export default UserInfo
